import { Controller } from "@hotwired/stimulus"
import { Stepper } from "mdb-ui-kit"
import { useIntersection } from "stimulus-use"

export default class extends Controller {
  connect() {
    useIntersection(this)
  }

  appear() {
    this.initStepper()
  }

  initStepper() {
    if (this.element._stepper) {
      return
    }
    // initialize new Stepper
    new Stepper(this.element)
  }
}
